import { TOPICS } from './constants/topics_c';
import _u from './util';
import _v from './vars';
import _t from './templates/templates_t';
import _ from 'lodash';

let topicList = [];
let buttonValue = {};
if (typeof userHpId != 'undefined' && userHpId != '' && !isNaN(Number(userHpId))) {
    let modifiedHomepageId = userHpId;
    modifiedHomepageId == '1' ? modifiedHomepageId = "3" : modifiedHomepageId = modifiedHomepageId;
    let value = _.filter(TOPICS, {
        'userHpId': modifiedHomepageId
    });
    if (value.length != 0) {
        topicList = JSON.parse(JSON.stringify(value[0].topics));
        buttonValue.show_more_button = value[0].show_more_button;
    }
}

function getTopicsWidg() {
    _u.apiGet('https://profreg.' + _u.getDomain(true) + 'medscape.com/px/columns/getallsubscriptions/1?'+ Math.random().toString().split('.')[1], true).then(data => {
        let ulTopics = document.getElementById('topicsList');
        ulTopics.innerHTML = '';
        let button = document.getElementById('show-more-topic');
        button.innerHTML = '';
        let list = [];

        if (data.subsciptionList && topicList.length != 0) {
            document.getElementById('topicsToFollow').classList.add("active");
            if (data.subsciptionList.length > 0) {
                data.subsciptionList.forEach((element, index) => {
                    let value = _.filter(topicList, {
                        'id': element.toString()
                    });
                    if (value && value.length > 0) {
                        list.push(value[0]);
                        value[0].fromDb = true;
                    }
                });
            }
            let initialLength = list.length;

            if (initialLength > 0 && initialLength >= 3) {
                let sortedList = _.sortBy(list, ['name']);
                sortedList.forEach((element, index) => {
                    if (index > 2) {
                        return;
                    }
                    ulTopics.appendChild(_u.strToDom(_t.checkedtopicLink(element)));
                });
            }

            if (initialLength > 0 && initialLength <= 2) {
                let value = _.filter(topicList, { fromDb: false });

                value.forEach((element, index) => {
                    if (initialLength > 2) {
                        return;
                    }
                    list.push(element);
                    initialLength += 1;
                });


                let sortedList = _.sortBy(list, ['name']);
                sortedList.forEach((element, index) => {
                    if (index > 2) {
                        return;
                    }
                    if (element.fromDb == true) {
                        ulTopics.appendChild(_u.strToDom(_t.checkedtopicLink(element)));
                    } else {
                        ulTopics.appendChild(_u.strToDom(_t.uncheckedtopicLink(element)));
                    }
                });
            }

            if (initialLength === 0) {
                topicList.forEach((element, index) => {
                    if (index > 2) {
                        return;
                    }
                    list.push(element);
                });

                let sortedList = _.sortBy(list, ['name']);

                sortedList.forEach((element, index) => {
                    if (index > 2) {
                        return;
                    }
                    ulTopics.appendChild(_u.strToDom(_t.uncheckedtopicLink(element)));
                });
            }

            var li = document.getElementsByClassName("pers-topic-item");

            for (var i = 0; i < li.length; i++) {
                li[i].addEventListener("click", (e) => {
                    let target = getEventTarget(e);
                    let li = target.closest('li');
                    let newnode = [];
                    li.closest('ul').children.forEach(element => {
                        newnode.push(element);
                    });
                    // let nodes = Array.from(li.closest('ul').children);
                    let index = newnode.indexOf(li);

                    let value = _.filter(topicList, { 'name': e.target.innerText.toString().trim() });
                    if (value.length > 0) {
                        if (value[0].fromDb === true) {
                            value[0].fromDb = false;
                            removeTopic(value[0].id.toString(), index + 1);
                        } else {
                            value[0].fromDb = true;
                            addTopic(value[0].id.toString(), value[0].name.toString(), index + 1);
                        }
                    }
                });
            }

            let button = document.getElementById('show-more-topic');
		    button.appendChild(_u.strToDom(_t.showMoreTopicButton(buttonValue)));

            document.getElementById("show-more-topic").addEventListener("click", function () {
                wmdPageLink('fy-rr_atyfsm', this)
            });
        }
        removeRightLoader();
    }).catch((error) => {
        removeRightLoader();
    });
}

function getEventTarget(e) {
    e = e || window.event;
    return e.target || e.srcElement;
}

function addTopic(topicID, topicName, index) {
    _u.apiGet('https://profreg.' + _u.getDomain(true) + 'medscape.com/px/columns/addalert/1/' + topicID + '?' + Math.random().toString().split('.')[1], true).then(data => {
        if (data.ok === true) {
            getTopicsWidg();
            wmdPageLink('fy-rr_atyf' + index.toString(), this);
            document.getElementById('notification').classList.add('active');
            document.getElementById('specialty-name').innerText = '"' + topicName + '"';
            setTimeout(function () {
                document.getElementById("notification").classList.remove("active");
            }, 6000);
        }
    }).catch((error) => {
        console.log(error);
    });
}

function removeTopic(topicID, index) {
    _u.apiGet('https://profreg.' + _u.getDomain(true) + 'medscape.com/px/columns/removealert/1/' + topicID + '?' + Math.random().toString().split('.')[1], true).then(data => {
        if (data.ok === true) {
            wmdPageLink('fy-rr_rtyf' + index.toString(), this);
            getTopicsWidg();
        }
    }).catch((error) => {
        console.log(error);
    });
}

function removeRightLoader() {
    let rightRailLoadingSection = document.getElementById('right-rail-loading-section');
    if(rightRailLoadingSection != null) {
        _u.removeElem(rightRailLoadingSection);

        let rightRailLoadingCompleteSection = document.getElementById('right-rail-loading-complete-section');
        rightRailLoadingCompleteSection.classList.add("active");
    }
}

export default getTopicsWidg;